<template>
    <div class="p-2" style="width:250px">
      <vs-row vs-type="flex" vs-justify="center">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" >
          {{$t('Actual')}} : {{ initialValue }}
        </vs-col>
      </vs-row>
      <div class="vx-row ml-2 mr-2 mt-2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">        
        <vs-row class="mt-2">
          <vs-col class="mb-1" vs-w="12">
            <vs-chip class="mt-2 mr-2" color="primary" >
              {{$t('GradeControl.Timesheet.TimesheetOperationType')}}
            </vs-chip>
            <v-select
              label="name"
              :options="timesheetOperationTypes"
              :reduce="v => v.id"
              v-model="timesheetOperationType"
              @input="setSelected"
              class="w-full"
              name="timesheetOperationType"
            />
          </vs-col>
        </vs-row>
      </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import TimesheetOperationTypeEnum from "../../TimesheetOperationTypeEnum";

export default {
  name: 'TimesheetOperationTypeCellEditor',
  data() {
    return {
      timesheetOperationType: null,
      timesheetOperationTypes: TimesheetOperationTypeEnum.definition
    }
  },
  computed: {
    initialValue() {
      return this.$t("GradeControl.TimesheetOperationType." + this.params.value.timesheetOperationType);
    }
  },
  components: {
    'v-select': vSelect
  },
  created() {
    this.timesheetOperationType = this.params.value.timesheetOperationType;
  },
  methods: {
    getValue() {
      const timesheetOperationType = this.timesheetOperationType;
      return {
        timesheetOperationType
      };
    },
    isPopup() {
      return true;
    },
    setSelected(value) {
      this.timesheetOperationType  = value;
      this.params.api.stopEditing();
    }
  }
}
</script>
